import React from 'react';
import classNames from 'classnames';
import style from './styles.scss';

const StatusContainer = ({ typoNo, sets }) => {
  return (
    <div className={style.statusContainer}>
      <p className={style.viewHeader}>Overview</p>
      <div>
        <p className={classNames(style.typoDetailsHead, style.typoOne)}>
          This run instance has
          <span className={style.fontBlue}> {sets} Sets, </span>
          and a total of{' '}
          <span className={style.fontBlue}> {typoNo} typologies </span>
        </p>
      </div>
    </div>
  );
};

export default StatusContainer;
